import LoadMap, { Segments } from './LoadMap'
export {
  Segments
}
export default LoadMap